module.exports = __webpack_public_path__ + "img/energy.4ff9f5cb.svg";